<label class="switch" [class.disabled]="disabled" (click)="onChange()">
  <input #checkbox type="checkbox" [attr.checked]="checked ? true : null" disabled />
  <span class="switch-slider">
    <div class="basic-atom center-child">
      <div class="text">{{ text | translate }}</div>
    </div>
  </span>
</label>
